// client/src/components/ProductTools.js
import React from "react";
import { IconButton, Tooltip } from "@mui/material";

// Mapping des codes pays vers leurs domaines Amazon
const amazonDomains = {
  FR: "amazon.fr",
  DE: "amazon.de",
  ES: "amazon.es",
  IT: "amazon.it",
  UK: "amazon.co.uk",
  US: "amazon.com",
  CA: "amazon.ca",
  MX: "amazon.com.mx",
  BR: "amazon.com.br",
  JP: "amazon.co.jp",
  IN: "amazon.in",
  AU: "amazon.com.au",
  AE: "amazon.ae",
  SG: "amazon.sg",
  NL: "amazon.nl",
  PL: "amazon.pl",
  SE: "amazon.se",
  TR: "amazon.com.tr",
  SA: "amazon.sa",
};

const ProductTools = ({ asin, countryCode = "FR" }) => {
  const amazonDomain = amazonDomains[countryCode] || "amazon.fr";
  const amazonLink = `https://www.${amazonDomain}/dp/${asin}`;
  const sellerAmpLink = `https://sas.selleramp.com/sas/lookup?SasLookup%5Bsearch_term%5D=${asin}`;
  const keepaLink = `https://keepa.com/#!product/4-${asin}`;

  return (
    <div style={{ display: "flex", gap: "4px" }}>
      <Tooltip title={`Rechercher sur Amazon ${countryCode}`}>
        <IconButton
          size="small"
          href={amazonLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/amazon.png" alt="Amazon" style={{ width: 20, height: 20, display: 'block' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Rechercher sur SellerAmp">
        <IconButton
          size="small"
          href={sellerAmpLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/sas.png" alt="SellerAmp" style={{ width: 20, height: 20, display: 'block' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Rechercher sur Keepa">
        <IconButton
          size="small"
          href={keepaLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/keepa.png" alt="Keepa" style={{ width: 20, height: 20, display: 'block' }} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ProductTools;
